export default "__VITE_ASSET__DU3U1xwF__"